<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px" transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <span class="headline">用户登录</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- <v-col cols="12">
                <v-text-field
                  label="用户名*"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="密码*"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  required
                ></v-text-field>
              </v-col> -->
              <v-col cols="12">
                <div class="mt-2"><small>第三方认证登录方式：</small></div>
                <!-- <div class="mt-2"><a @click="openid_login"><v-icon>mdi-login</v-icon>网易内部OpenID认证登录</a></div> -->
                <div class="mt-2"><a href="/oauth/login/github" style="text-decoration-line:none;"><v-icon>mdi-github</v-icon>Github第三方认证登录</a></div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">关闭</v-btn>
          <!-- <v-btn color="blue darken-1" text @click="login">登录</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    dialog: true,
    show1: false,
  }),
  methods: {
    // $emit 子组件处罚父子间的自定义事件 可以传递参数过去
    close() {
      this.$emit("close", false);
    },
    // 未使用
    async login() {
      console.log(this.model);
      const res = await this.$http.post("login/", this.model);
      console.log(res.data);
      if (res.data.error_num === 0) {
        localStorage.setItem("name", this.model.username);
        localStorage.token = res.data.token;
        this.$emit("login", true);
      }
      this.$emit("close", false); 
    },
    openid_login(){
      var that = this
      this.$axios.get('/login/',)
      .then(function(response){
        var url = response.data.url
        window.location.replace(url)
      })
      .catch(function(error){
        alert(error)
      })
    }
  }
};
</script>